import breakpointIs from "../../modules/breakpointIs";
export const scrollTo = (scrollToElement, ops = {}) => {
  const navigationHeight = document.querySelector("nav.mega-nav")?.offsetHeight || 0;
  const pageMenuHeight = document.querySelector(".tabLink")?.offsetHeight || 0;
  
  const totalStickyHeight = navigationHeight + pageMenuHeight;
  const scrollToElementPos = scrollToElement.getBoundingClientRect().top;
  const elementTopPos =
    scrollToElementPos - document.body.getBoundingClientRect().top;
  const topPos = elementTopPos - totalStickyHeight;

  window.scrollTo({
    top: topPos,
    behavior: "smooth",
    ...ops,
  });
};
